import React, { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchAllVendorShipmentsWithFilters } from 'store/shipmentSummary/actionCreator'
import AllShipmentsFiltersCanvas from './AllShipmentsFiltersCanvas'
import { Grid } from '@enterprise-ui/canvas-ui-react'
import CustomCanvasTable from 'components/CanvasTable/CustomCanvasTable'

export default function AllShipments(props) {
  const {
    columnData = [],
    allVendorShipments = [],
    fetchAllShipmentsPending = false,
    filterOptions = {},
  } = props
  const dispatch = useDispatch()
  const [selectedFilters, setSelectedFilters] = useState({})

  useEffect(() => {
    dispatch(
      fetchAllVendorShipmentsWithFilters(
        {
          shipment_ids: [],
          pegasus_ids: [],
          tracking_numbers: [],
        },
        true
      )
    )
  }, [])

  useEffect(() => {
    dispatch(
      fetchAllVendorShipmentsWithFilters({
        shipment_ids: selectedFilters['shipmentId']
          ? selectedFilters['shipmentId'].map(
              (shipmentIds) => shipmentIds.value
            )
          : [],
        pegasus_ids: selectedFilters['pegasusId']
          ? [selectedFilters['pegasusId']]
          : [],
        tracking_numbers: selectedFilters['trackingNum']
          ? selectedFilters['trackingNum'].map(
              (trackingNum) => trackingNum.value
            )
          : [],
      })
    )
  }, [selectedFilters])
  return (
    <Grid.Container
      spacing={'none'}
      direction="column"
      style={{ padding: '12px' }}
    >
      <AllShipmentsFiltersCanvas
        filtersOptions={filterOptions}
        filterValues={selectedFilters}
        setSelectedFilters={(filters = {}) => setSelectedFilters(filters)}
      />
      <div style={{ height: '40px' }}></div>
      <CustomCanvasTable
        columnData={columnData}
        data={allVendorShipments}
        disablePaging
        enableSearch
        enableMultiSearch={true}
        isLoading={fetchAllShipmentsPending}
      />
    </Grid.Container>
  )
}
